import React from 'react';
import { Row, Col } from 'tea-component';
import GamePerformanceSummary from './components/GamePerformanceSummary';
import About from './components/About';
import RecentNewsActivity from './components/RecentNewsActivity';
import Games from './components/Games';

import type { ICompaniesDetailsPageBaseProps } from '../types';

import '@/pages/intelligence/assets/scss/TopCharts/Companies/GamesDetails/summary.scss';

const Summary: React.FC<ICompaniesDetailsPageBaseProps> = (props) => {
  return (
    <div className="dbi-summary">
      <GamePerformanceSummary {...props} />
      <Row className="dbi-about-context">
        <Col span={12}>
          <About {...props} />
        </Col>
        <Col span={12}>
          <RecentNewsActivity {...props} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Games {...props} />
        </Col>
      </Row>
    </div>
  );
};

export default Summary;
